import axiosInstance from 'Api';

const withCommunity = (path, communityId, extraParams = {}) => {
    const params = new URLSearchParams({ community_id: String(communityId) });
    Object.entries(extraParams).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
            params.set(key, String(value));
        }
    });
    return `${path}?${params.toString()}`;
};

const getTabCounts = (communityId) =>
    axiosInstance.get(withCommunity('afas/tabs/counts', communityId));

const getConfiguredCommunities = () => axiosInstance.get('afas/communities');

const getConflicten = (communityId, filter = 'open') =>
    axiosInstance.get(withCommunity('afas/conflicten', communityId, { filter }));

const updateConflictVerbergen = (id, verbergen) =>
    axiosInstance.patch(`afas/conflicten/${id}`, { verbergen });

const resolveConflict = (id, gekozenWaarde) =>
    axiosInstance.post(`afas/conflicten/${id}/resolve`, { gekozenWaarde });

const getSynchronisatie = (communityId) =>
    axiosInstance.get(withCommunity('afas/synchronisatie', communityId));

const getHistorie = (communityId, period = null) =>
    axiosInstance.get(withCommunity('afas/historie', communityId, { period }));

const getHistoriePeriods = (communityId) =>
    axiosInstance.get(withCommunity('afas/historie/periods', communityId));

const getOpenstaandVerzoeken = (communityId, { week = null, mode = null } = {}) =>
    axiosInstance.get(withCommunity('afas/openstaand/verzoeken', communityId, { week, mode }));

const getOpenstaandVerzoek = (
    communityId,
    substitutionId,
    { substitutorAdminId = null, week = null, prolongedId = null } = {},
) =>
    axiosInstance.get(
        withCommunity(`afas/openstaand/verzoeken/${substitutionId}`, communityId, {
            substitutor_admin_id: substitutorAdminId,
            week,
            prolonged_id: prolongedId,
        }),
    );

const getOpenstaandWeeks = (communityId, mode = null) =>
    axiosInstance.get(withCommunity('afas/openstaand/weken', communityId, { mode }));

const getOpenstaandListItems = (
    communityId,
    { substitutorAdminId = null, week = null } = {},
) =>
    axiosInstance.get(
        withCommunity('afas/openstaand/list-items', communityId, {
            substitutor_admin_id: substitutorAdminId,
            week,
        }),
    );

const getOpenstaandVerzuimVerlof = (
    communityId,
    { vervangt = null, week = null, periodStart = null, periodEnd = null } = {},
) =>
    axiosInstance.get(
        withCommunity('afas/openstaand/verzuim-verlof', communityId, {
            vervangt,
            week,
            period_start: periodStart,
            period_end: periodEnd,
        }),
    );

const getOpenstaandExtra = (
    communityId,
    substitutionId,
    { substitutorAdminId = null, week = null, volgnummerDvb = null, vervangt = null } = {},
) =>
    axiosInstance.get(
        withCommunity(`afas/openstaand/verzoeken/${substitutionId}/extra`, communityId, {
            substitutor_admin_id: substitutorAdminId,
            week,
            volgnummer_dvb: volgnummerDvb,
            vervangt,
        }),
    );

const getOpenstaandReference = (communityId, type) =>
    axiosInstance.get(withCommunity(`afas/openstaand/reference/${type}`, communityId));

const searchOpenstaandEmployees = (communityId, query, limit = 20) =>
    axiosInstance.get(
        withCommunity('afas/openstaand/search-employees', communityId, { q: query, limit }),
    );

const saveOpenstaandState = (communityId, substitutionId, payload) =>
    axiosInstance.put(
        withCommunity(`afas/openstaand/verzoeken/${substitutionId}/state`, communityId),
        payload,
    );

const createOpenstaandDagdeel = (communityId, substitutionId, payload) =>
    axiosInstance.post(
        withCommunity(`afas/openstaand/verzoeken/${substitutionId}/dagdelen`, communityId),
        payload,
    );

const updateOpenstaandDagdeel = (communityId, dagdeelId, payload) =>
    axiosInstance.patch(
        withCommunity(`afas/openstaand/dagdelen/${dagdeelId}`, communityId),
        payload,
    );

const deleteOpenstaandDagdeel = (communityId, dagdeelId) =>
    axiosInstance.delete(withCommunity(`afas/openstaand/dagdelen/${dagdeelId}`, communityId));

const saveOpenstaandMemo = (communityId, substitutionId, payload) =>
    axiosInstance.patch(
        withCommunity(`afas/openstaand/verzoeken/${substitutionId}/memo`, communityId),
        payload,
    );

const updateOpenstaandProlonged = (communityId, prolongedId, payload) =>
    axiosInstance.patch(
        withCommunity(`afas/openstaand/prolonged/${prolongedId}`, communityId),
        payload,
    );

const verwerkenOpenstaand = (communityId, substitutionId, payload) =>
    axiosInstance.post(
        withCommunity(`afas/openstaand/verzoeken/${substitutionId}/verwerken`, communityId),
        payload,
    );

const AfasService = {
    getTabCounts,
    getConfiguredCommunities,
    getConflicten,
    updateConflictVerbergen,
    resolveConflict,
    getSynchronisatie,
    getHistorie,
    getHistoriePeriods,
    getOpenstaandVerzoeken,
    getOpenstaandVerzoek,
    getOpenstaandWeeks,
    getOpenstaandListItems,
    getOpenstaandVerzuimVerlof,
    getOpenstaandExtra,
    getOpenstaandReference,
    searchOpenstaandEmployees,
    saveOpenstaandState,
    createOpenstaandDagdeel,
    updateOpenstaandDagdeel,
    deleteOpenstaandDagdeel,
    saveOpenstaandMemo,
    updateOpenstaandProlonged,
    verwerkenOpenstaand,
};

export default AfasService;
